export default __webpack_public_path__ + "static/media/gallery-wip-crystal-holder_01.c649a7b3.jpg";